module.exports = __webpack_public_path__ + "img/VideoCameraFrontOutlined.1c05dfc9.svg";